// extracted by mini-css-extract-plugin
export default {"container":"JPP2G","category":"Upks4 ZdH1P"};